module.exports = __webpack_public_path__ + "img/DE01895.703a86f2.png";